import React from "react";
import styles from "./integration.module.css";
const IntegrationConfig = ({ ConfigInfoData }) => {
  const checkConfigValueType = (value) => {
    return typeof value === "boolean" ? (value ? "True" : "False") : value;
  };
  return (
    <div style={{ padding: 20 }}>
      <div className={styles["integration-container"]}>
        {ConfigInfoData?.integration_config.map((item, index) => (
          <div className={styles["item"]} key={index}>
            <p>
              <strong>Key: {item?.key || "N/A"}</strong>
            </p>
            <p>Stage: {item?.stage || "N/A"}</p>
            <p>Value: {checkConfigValueType(item?.value) || "N/A"}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default IntegrationConfig;
